import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable()
export class WorkplacePluginPairingService {
    readonly PLAYER_CONTENT_URL: string = environment.pluginConfig.svcnow.contentUrl;
}